import { useGlobSetting } from '@/hooks/setting';
import qs from 'qs';
import { isUrl } from './is';
import { checkCookieApi } from '@/api/user';
/**
 * 根据文件url获取文件名
 * @param url 文件url
 */
function getFileName(url) {
  const num = url.lastIndexOf('/') + 1;
  let fileName = url.substring(num);
  //把参数和文件名分割开
  fileName = decodeURI(fileName.split('?')[0]);
  return fileName;
}

interface DownloadByUrlConfig {
  target?: '_self' | '_blank';
  fileName?: string;
  params?: any;
}

/**
 * @description get请求根据文件地址下载文件
 * @param {string} url 下载文件请求的url。可传入完整url，或者不带api请求前缀的接口地址（则域为当前地址）
 * @param {{target?: '_self' | '_blank',fileName?: string}} config 下载文件时的配置，target默认为_seft
 * @returns {Promise<boolean>} Promise<boolean>
 */

export async function downloadByUrl(url: string, config?: DownloadByUrlConfig): Promise<boolean> {
  const res = await checkCookieApi();
  if (!res) {
    window['$message'].error('Get user info error');
    location.replace('/new/home/index');
  }
  const { urlPrefix } = useGlobSetting();
  const { target = '_seft', fileName } = config || {};
  if (!isUrl(url)) {
    url = window.location.origin + (url.startsWith('/') ? urlPrefix + url : urlPrefix + '/' + url);
  }
  url += `?${qs.stringify(config?.params, { indices: false })}`;
  // 是否同源
  const isSameHost = new URL(url).host == location.host;
  return new Promise<boolean>((resolve, reject) => {
    if (isSameHost) {
      const link = document.createElement('a');
      link.href = url;
      link.target = target;
      if (link.download !== undefined) {
        link.download = fileName || getFileName(url);
      }

      if (document.createEvent) {
        const e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        link.dispatchEvent(e);
        return resolve(true);
      }

      if (url.indexOf('?') === -1) {
        url += '?download';
      }

      window.open(url, target);
      return resolve(true);
    } else {
      const canvas = document.createElement('canvas');
      const img = document.createElement('img');
      img.setAttribute('crossOrigin', 'Anonymous');
      img.src = url;
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext('2d')!;
        context.drawImage(img, 0, 0, img.width, img.height);
        // window.navigator.msSaveBlob(canvas.msToBlob(),'image.jpg');
        // saveAs(imageDataUrl, '附件');
        canvas.toBlob((blob) => {
          const link = document.createElement('a');
          if (!blob) return window['$message'].error('downloadfile fail!');
          link.href = window.URL.createObjectURL(blob);
          link.download = getFileName(url);
          link.click();
          URL.revokeObjectURL(link.href);
          resolve(true);
        }, 'image/jpeg');
      };
      img.onerror = (e) => reject(e);
    }
  });
}
